import { render, staticRenderFns } from "./buyCardRecord.vue?vue&type=template&id=58f10b03&scoped=true"
import script from "./buyCardRecord.vue?vue&type=script&lang=js"
export * from "./buyCardRecord.vue?vue&type=script&lang=js"
import style0 from "./buyCardRecord.vue?vue&type=style&index=0&id=58f10b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f10b03",
  null
  
)

export default component.exports